// Generic filter utilities - NO API calls, NO business logic

export const filterFormItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

export const filterTailLayout = {
  wrapperCol: { span: 24 },
};

export const defaultTokenSeperators = [',', ' '];

export const isInvalidFilter = (value: any): boolean => {
  if (
    value === null ||
    value === undefined ||
    ((typeof value === 'string' || Array.isArray(value)) && !value.length) ||
    (value instanceof Object && !Object.keys(value).length)
  ) {
    return true;
  }
  return false;
};

export const sanitiseObject = (filters: any): any => {
  const obj = { ...filters };
  for (const i in obj) {
    if (isInvalidFilter(obj[i])) {
      delete obj[i];
    }
  }
  return obj;
};

